export default "<app-loader-common></app-loader-common>\r\n<div class=\"layout-body\">\r\n    <router-outlet></router-outlet>\r\n</div>"